import { toast } from "react-toastify";
import { TRPCClientError } from "@trpc/client";

/**
 * Handles TRPC errors with specific error codes and fallback to generic message
 * @param error - The error object
 * @param fallbackMessage - Generic error message to show if no specific error code matches
 */
export function handleTRPCError(error: unknown, fallbackMessage: string): void {
    // Check if it's a TRPCClientError
    if (error instanceof TRPCClientError) {
        const data = error.data as { code?: string; zodError?: unknown } | undefined;
        const passThroughCodes = new Set(["BAD_REQUEST", "NOT_FOUND", "CONFLICT", "INTERNAL_SERVER_ERROR"]);

        if (data?.code && passThroughCodes.has(data.code) && !data?.zodError) {
            toast.error(error.message);
        } else {
            toast.error(fallbackMessage);
        }
    } else {
        // Fallback for non-TRPC errors
        toast.error(fallbackMessage);
    }
}
